<template>
  <div>
    <div class="orderStatus">
      <div class="orderStatus_box">
        <img class="orderStatus_img" src="/static/qiangdanchenggong.png" />
        <img class="orderStatus_erweima" src="/static/shoperweima.jpg" />
      </div>

    </div>
  </div>
</template>

<script>
  export default{
    data(){
      return{

      }
    },
    created() {

    },
    mounted() {

    },
    methods:{

    }
  }
</script>

<style>
  .orderStatus{
    width: 100%;
    height: 100%;
  }
  .orderStatus_box{
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    position: absolute;
    top: 10%;
    left: 27%;
  }
  .orderStatus_img{
    width: 170px;
    height: 170px;
    margin-bottom: 10px;
  }
  .orderStatus_detail{
    width: 115px;
    height: 39px;
    border: 1px solid #FD8C00;
    border-radius: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 16px;
    color: #FD8C00;
  }
  .orderStatus_erweima{
    width: 180px;
    height: 180px;

  }
</style>



// WEBPACK FOOTER //
// src/pages/orderGrabbing/orderStatus.vue